import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { FC } from 'react';

export const TableLoading: FC = () => {
  return (
    <div className="w-full rounded-10 border bg-white overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow className="bg-gray-100 hover:bg-gray-100">
            {Array.from({ length: 6 }).map((_, index) => (
              <TableHead className="py-3" key={index}>
                <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {Array.from({ length: 4 }).map((_, i) => (
            <TableRow className="" key={i}>
              {Array.from({ length: 6 }).map((_, index) => (
                <TableCell className="py-3" key={index}>
                  <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
